import { useEffect, type ReactNode } from 'react';
import { useAuth } from '@tagna/auth';
import { tokenProvider } from '@/services/base/token-provider';

/**
 * AuthTokenProvider Component
 *
 * Bridges the OIDC auth context with the BaseService token provider
 * This component registers the getAccessToken function from the auth context
 * so that API services can retrieve authentication tokens
 */
export function AuthTokenProvider({ children }: { children: ReactNode }) {
  const { getAccessToken } = useAuth();

  useEffect(() => {
    // Register the token provider function
    tokenProvider.setTokenProvider(getAccessToken);

    // Cleanup on unmount
    return () => {
      tokenProvider.clearTokenProvider();
    };
  }, [getAccessToken]);

  return <>{children}</>;
}
